import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id1 = uuid.v4();
    const id2 = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id1})`}>
                <g clipPath={`url(#${id2})`}>
                    <rect width='24' height='24' rx='4' fill='#007832' />
                    <rect x='4.6665' y='6.66656' width='16' height='12' fill='white' />
                    <path
                        d='M24.2903 1.19119C24.5001 1.40101 24.619 1.68427 24.619 1.98151V23.5477C24.619 24.1666 24.119 24.6667 23.5 24.6667H1.11905C0.500074 24.6667 0 24.1666 0 23.5477V-5.54758C0 -6.16655 0.500074 -6.66663 1.11905 -6.66663H15.9709C16.2682 -6.66663 16.5549 -6.54773 16.7647 -6.33791L24.2903 1.19119ZM22.0382 2.49558L15.4568 -4.08582V2.49558H22.0382ZM14.5245 7.80546L12.3837 11.3829L10.2218 7.80406C10.1844 7.74226 10.1317 7.69114 10.0688 7.65567C10.0059 7.6202 9.93488 7.60157 9.86266 7.60158H8.5184C8.43919 7.60159 8.36159 7.62402 8.29459 7.66628C8.24793 7.69567 8.20753 7.73397 8.17568 7.77899C8.14384 7.82401 8.12118 7.87487 8.109 7.92865C8.09682 7.98243 8.09536 8.03809 8.1047 8.09244C8.11405 8.14678 8.13401 8.19876 8.16345 8.24538L11.0429 12.8062L8.12463 17.4496C8.08256 17.5165 8.06026 17.5939 8.06029 17.673C8.06029 17.7843 8.1045 17.891 8.1832 17.9697C8.2619 18.0484 8.36864 18.0927 8.47993 18.0927H9.68501C9.75658 18.0926 9.82696 18.0743 9.88945 18.0394C9.95195 18.0045 10.0045 17.9542 10.0421 17.8933L12.2347 14.3449L14.4133 17.8926C14.4509 17.9538 14.5035 18.0043 14.5661 18.0393C14.6288 18.0743 14.6993 18.0927 14.7711 18.0927H16.0818C16.1621 18.0927 16.2408 18.0696 16.3084 18.0262C16.3548 17.9965 16.3948 17.9578 16.4263 17.9126C16.4578 17.8674 16.48 17.8164 16.4917 17.7625C16.5035 17.7087 16.5045 17.6531 16.4948 17.5988C16.4851 17.5446 16.4647 17.4928 16.435 17.4464L13.5034 12.881L16.4864 8.24853C16.5299 8.18071 16.5529 8.1018 16.5528 8.02122C16.5528 7.90993 16.5086 7.80319 16.4299 7.72449C16.3512 7.64579 16.2445 7.60158 16.1332 7.60158H14.8847C14.8122 7.60163 14.741 7.62047 14.6779 7.65626C14.6148 7.69205 14.5618 7.74323 14.5245 7.80546Z'
                        fill='#007832'
                    />
                </g>
            </g>
            <defs>
                <clipPath id={id1}>
                    <rect width='24' height='24' fill='white' />
                </clipPath>
                <clipPath id={id2}>
                    <rect width='24' height='24' rx='4' fill='white' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
